module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-api-token":"Delete API Token","api-token-deleted":"API Token deleted","failed-delete-api-token":"Failed to delete API token"}}')
  delete Component.options._Ctor
}
